import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import * as firebase from "firebase/app";
import { deleteFileByUrl } from "@/utils/upload-image";

export default {
  name: "StaffDirectory",
  components: {
    ConfirmDlg
  },
  data() {
    return {
      facilityCopy: null,
      isInvalidFile: false,
      staffDirectoryFileUploading: false,
      deletingStaffDirectory: false,
    }
  },
  async created() {
    await this.$store.dispatch("getFacility");
    this.facilityCopy = { ...this.facility }
  },
  watch:{
    facility(newValue) {
      this.facilityCopy = { ...newValue }
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    }
  },
  methods: {
    async onPdfSelect(event) {

      if(!event.target.files[0]) return
  
      this.isInvalidFile = this.getExtension(event.target.files[0].name).toLowerCase() != 'pdf'
  
      if (this.isInvalidFile) return
  
      this.staffDirectoryFileUploading = true
  
      await this.uploadFile(event.target.files[0])
    },
  
    async deleteStaffDirectory(){

      const fileUrl = this.facility?.staffDirectory?.fileUrl
      if(fileUrl?.length > 0){
        (this.$refs.confirmationModal as any)
          .open(null, this.$t('Settings.FacilitySettings.DeleteStaffDirectoryFileQuestion'), false)
          .then(async (response) => {
            if (response && response.agree) {
              this.deletingStaffDirectory = true
              await firebase.firestore().collection("facility").doc(this.facility.id).update({ staffDirectory: firebase.firestore.FieldValue.delete() })
              await deleteFileByUrl(fileUrl)
              this.$refs.inputFileUpload.value = null;
              await this.$store.dispatch("getFacility");
              this.deletingStaffDirectory = false
            }
          });
      }
    },
  
    async uploadFile(file) {
      if (!file) return;
  
      try {
        const prevFileUrl = this.facilityCopy?.staffDirectory?.fileUrl || ''

        const storageRef = firebase.storage().ref()
  
        const filesRef = storageRef.child(this.facility.id).child('staffDirectory')
  
        let type = file.extension || file.type;
  
        if (type === 'pdf') {
          type = file.type;
        }
  
        const uploadFileRef = filesRef.child(`${file.name}`)
  
        await uploadFileRef.put(file, { contentType: type })
        const pdfUrl = await uploadFileRef.getDownloadURL()

        await firebase.firestore().collection("facility").doc(this.facility.id).update({
          staffDirectory: {
            fileUrl: pdfUrl,
            name: file.name,
            type: type,
            uploadedByStaffid: this.$store.state.authModule.user.id,
            dateTimeUploaded: new Date()
          }
        })
     
         if(prevFileUrl.length > 0){
            await deleteFileByUrl(prevFileUrl)
         }
  
         await this.$store.dispatch("getFacility");
  
         return pdfUrl
  
      } catch (error) {
        console.error(error)
      }
      finally {
        this.staffDirectoryFileUploading = false
      }
    },

    getExtension(filename) {
      const parts = filename.split('.')
      const ext = parts[parts.length - 1]
      return ext
    }
  
  }
}